declare namespace $ {

	export class $mol_icon_arrow_right extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=right.view.tree.d.ts.map